<template>
  <div>
    <div class="banner-wrap">
      <Banner class="pc-banner " :is-hitech="false" />
    </div>
    <TopBoardCategories
      :header="content.headerTxt"
      :subHeader="content.subHeaderTxt"
    />
    <div class="inner-wrap">
      <div class="section_inner">
        <ArticleBreadcrumbs :items="breadCrumbs" class="pr-3" />
        <v-layout column class="inner-content pt-3 mt-3">
          <v-flex>
            <v-layout wrap justify-space-between>
              <v-flex xl10 lg10 class="jobs-row" pa1>
                <v-layout wrap>
                  <v-flex v-for="(cat, i) in categories" :key="i" sm3 xs12>
                    <CategoryItem :catItem="cat" />
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex class="ads-row">
                <v-layout colomun wrap>
                  <v-flex>
                    <SectionCompaniesInnerPages
                      :is-hitech="false"
                      :page="'categoriesPage'"
                    />
                    <!-- <SectionCompaniesInnerPages /> -->
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>
    </div>
  </div>
</template>



<script>
import CategoryItem from '@/components/CategoriesPage/CategoryItem/CategoryItem';
import TopBoardCategories from '@/components/CategoriesPage/TopBoardCategories';

import SectionCompaniesInnerPages from '@/components/Jobs_List/SectionCompaniesInnerPages';
import Banner from '@/components/Jobs_List/Banner';
import { t } from '@/store/modules/homeDrushim/constantsContent';
import SeoOptimization from '@/components/mixins/SeoOptimization';
import { SUB_CATEGORIES, SEO, axiomLog } from '@/lib/api.js';

export default {
  layout: 'categories',
  name: 'categoriesPage',
  mixins: [SeoOptimization],
  components: {
    CategoryItem,
    TopBoardCategories,
    SectionCompaniesInnerPages,
    Banner
  },

  data() {
    return {
      content: t('titles.categoriesPage'),
      categories: {},
      breadCrumbs: []
    };
  },

  async asyncData(context) {
    try {
      const {
        data: { data: data }
      } = await context.$axios.get(SUB_CATEGORIES);
      const {
        data: { data: seo }
      } = await context.$axios.get(`${SEO}/?pageId=31`);

      await axiomLog(
        context.$axios,
        context.route.path,
        context.req,
        context.error
      );

      if (!data) {
        throw 'שגיאת מערכת ';
      }

      return {
        categories: data,
        breadCrumbs: [
          {
            name: 'home',
            value: 'דרושים',
            link: '/'
          },
          {
            name: 'categories',
            value: 'כל הקטגוריות',
            link: '/categories.aspx/'
          }
        ],
        seodata: {
          metaData: seo.seoModel.metaDataItems,
          pageTitle: seo.seoModel.title,
          breadCrumbsSchema: {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: 'Home page',
                item: 'https://www.drushim.co.il/'
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: 'כל הקטגוריות'
              }
            ]
          }
        }
      };
    } catch (e) {
      context.$sentry.captureException('all categories page error: ' + e);
      await axiomLog(context.$axios, context.route.path, context.req, e);
    }
  },
  head() {
    return {
      link: [
        {
          //canonical doesnt returned from api
          rel: 'canonical',
          href: 'https://www.drushim.co.il' + this.$route.fullPath
        }
      ],
      title: this.seodata.pageTitle,
      meta: this.seodata.metaData,
      __dangerouslyDisableSanitizers: ['script'],
      script: [
        {
          innerHTML: JSON.stringify(this.seodata.breadCrumbsSchema),
          type: 'application/ld+json'
        }
      ]
    };
  }
};
</script>


<style lang="scss" scoped>
.inner-wrap {
  min-height: 50vh;
}

.inner-content {
  padding: 0 5px;
}

.theme--light.v-list {
  background: transparent;
}

.jobs-row {
  max-width: 934px;
}

.ads-row {
  max-width: 300px;
}

.aside-ad {
  background: #3e4a54;
  text-align: center;
}

.mobile-banner {
  margin: 5px;
}

@media only screen and (min-width: 600px) {
  .inner-content {
    padding: 0;
  }
}

@media only screen and (min-width: 700px) {
  .filter-by-text {
    display: block;
  }
}

@media screen and (max-width: 1280px) {
  .jobs-row {
    max-width: 100%;
  }

  .ads-row {
    display: none;
  }
}
</style>
